'use client';
import React, { useState } from 'react';

export default function SubscribeSection() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
    }
  };

  return (
    <section className="relative py-20 md:py-28 overflow-hidden bg-brand-dark">
      {/* Background decorative elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-72 h-72 bg-brand-turmeric/5 rounded-full -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-brand-green/5 rounded-full translate-x-1/3 translate-y-1/3" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-px bg-gradient-to-r from-transparent via-brand-turmeric/10 to-transparent" />
      </div>

      <div className="relative container mx-auto px-4 max-w-3xl text-center">
        {/* Brand Tag */}
        <div className="inline-flex items-center gap-2 mb-6">
          <span className="w-8 h-px bg-brand-turmeric" />
          <span className="text-brand-turmeric font-avenir text-xs font-semibold uppercase tracking-[0.2em]">
            Stay Informed
          </span>
          <span className="w-8 h-px bg-brand-turmeric" />
        </div>

        <h2 className="text-3xl md:text-5xl font-bold text-white font-avenir mb-5 leading-tight">
          Exclusive Investment <br className="hidden md:block" />
          <span className="text-brand-turmeric">Insights & Opportunities</span>
        </h2>

        <p className="text-white/60 font-avenir text-base leading-relaxed mb-4 max-w-xl mx-auto">
          Be the first to access curated investment opportunities, market intelligence, and premium plotted ventures across Hyderabad's high-growth corridors.
        </p>

        {/* Feature pills */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {['New Launch Alerts', 'Market Reports', 'Exclusive Pre-Sales'].map((item) => (
            <span
              key={item}
              className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full border border-white/10 bg-white/5 text-white/70 font-avenir text-xs"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-brand-turmeric flex-shrink-0" />
              {item}
            </span>
          ))}
        </div>

        {submitted ? (
          <div className="bg-brand-green/10 border border-brand-green/20 rounded-2xl p-8 max-w-md mx-auto">
            <div className="w-12 h-12 rounded-full bg-brand-green/20 flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-brand-green" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <div className="text-white font-avenir font-semibold text-lg mb-2">You're on the list!</div>
            <p className="text-white/50 font-avenir text-sm">
              Thank you for subscribing. Expect curated investment insights and exclusive venture updates directly in your inbox.
            </p>
          </div>
        ) : (
          <div className="max-w-lg mx-auto">
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                required
                className="flex-1 px-5 py-4 rounded-xl border border-white/10 bg-white/5 text-white font-avenir text-sm focus:outline-none focus:ring-2 focus:ring-brand-turmeric/50 focus:border-brand-turmeric/50 placeholder-white/30 backdrop-blur-sm"
              />
              <button
                type="submit"
                className="px-8 py-4 bg-brand-turmeric text-white font-semibold rounded-xl font-avenir text-sm hover:bg-brand-turmeric-light transition-all duration-200 whitespace-nowrap shadow-lg shadow-brand-turmeric/20"
              >
                Subscribe Now
              </button>
            </form>
            <p className="text-white/30 font-avenir text-xs mt-4">
              No spam, ever. Unsubscribe at any time. Your privacy is our priority.
            </p>
          </div>
        )}
      </div>
    </section>
  );
}
